export const VideoThumbnailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#000"
        fillOpacity=".75"
        stroke="#FFF"
        strokeOpacity="1"
        d="M22 1c11.598 0 21 9.402 21 21s-9.402 21-21 21S1 33.598 1 22 10.402 1 22 1zm-6 10.018a2 2 0 00-2 2h0v17.964a2 2 0 003.023 1.719h0l16.533-9.842a1 1 0 000-1.718h0l-16.533-9.842A2 2 0 0016 11.018z"
      />
      <path
        fill="#FFF"
        fillOpacity="1"
        d="M33.556 22.86L17.023 32.7A2 2 0 0114 30.983V13.018a2 2 0 013.023-1.719l16.533 9.842a1 1 0 010 1.718z"
      />
    </g>
  </svg>
);
